import loadable from '@loadable/component';
import { Box } from '@simplywallst/ui-core';
import { pluralise } from '@/utilities/pluralise';
import type { Portfolio } from '@/hooks/portfolio/usePortfolio';

import { useUserAccess } from '@/hooks/useUserAccess';
import { useHoldingsLimits } from '@/hooks/portfolio/useHoldingsLimits';

const PortfolioLimitsBanner = loadable(
  () => import('../PortfolioLimitsBanner'),
  {
    resolveComponent: (c) => c.PortfolioLimitsBanner,
  }
);

interface Props {
  portfolio: Portfolio;
}

export const DividendPanel = ({ portfolio }: Props) => {
  const { data: userAccess } = useUserAccess();

  const { excludedHoldings } = useHoldingsLimits({
    portfolioHoldings: portfolio?.holdings,
  });

  return (
    <>
      {excludedHoldings.length > 0 ? (
        <Box marginBottom="x2" minHeight="56px">
          <PortfolioLimitsBanner
            data-cy-id="excluded-holdings-banner-holdings-panel"
            content={`${excludedHoldings.length} ${pluralise(
              excludedHoldings.length,
              'holding',
              'holdings'
            )} excluded from analysis due to ${
              userAccess.planType
            } plan limit being reached. Upgrade for full access.`}
          />
        </Box>
      ) : null}
    </>
  );
};
